import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useAppSelector } from 'conversional-journey';
import { conditionalUtils } from 'conversional-utils';
import get from "lodash/get";
var ConditionalWrapper = function (_a) {
    var conditional = _a.conditional, children = _a.children, conditionalProps = _a.conditionalProps;
    var updatedAt = useAppSelector(function (_a) {
        var updatedAt = _a.common.updatedAt;
        return ({ updatedAt: updatedAt });
    }).updatedAt;
    if (!isEmpty(conditional)) {
        if (!conditionalUtils.processConditional(conditional)) {
            return null;
        }
    }
    var isDirectComponent = get(children, 'type.displayName') !== "ErrorBoundary";
    if (!isEmpty(conditionalProps)) {
        var processedProps = conditionalUtils.processConditionalProps(children.props, conditionalProps, isDirectComponent);
        return React.cloneElement(children, processedProps);
    }
    return children;
};
export default (ConditionalWrapper);
